import React, { useRef, useState } from 'react';
import { Alert, Form } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { launchCSV } from '../../api/assessments-api';
import { useAuth } from '../../providers/auth-provider';
import LoadingSpinner from '../common/loading-spinner';

function LaunchUploadContent({ selectionMade }) {
  const auth = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showLaunchMessage, setShowLaunchMessage] = useState(false);
  const [launchMessage, setLaunchMessage] = useState([]);
  const fileInputRef = useRef();

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    const launchData = {
      select: auth.isSelect(),
      develop: !auth.isSelect(),
      csv: selectedFile,
      sendEmail: true,
    };
    setSubmitting(true);
    try {
      const launchStatistics = await launchCSV(auth, launchData);
      setLaunchMessage([
        `Total submissions: ${launchStatistics.total}`,
        `Invitations sent: ${launchStatistics.success}`,
        `Details downloaded to: ${launchStatistics.filename}`,
      ]);
      setSubmitting(false);
      setShowLaunchMessage(true);

      setSelectedFile(null);
      fileInputRef.current.value = '';
    } catch (error) {
      setSubmitting(false);
    }
  };

  return (
    <>
      {submitting && <LoadingSpinner />}
      <Stack className="w-100 p-4 d-flex justify-content-center">
        {showLaunchMessage && (
          <Alert
            className="m-auto m-0 mb-4"
            style={{ width: '30%' }}
            variant="success"
            onClose={() => setShowLaunchMessage(false)}
            dismissible
          >
            {launchMessage.map((line) => (
              <div key={Math.random()}>{line}</div>
            ))}
          </Alert>
        )}
        <Container className="w-25 h-100">
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Upload CSV File</Form.Label>
            <Form.Control
              ref={fileInputRef}
              type="file"
              label={selectedFile ? selectedFile.name : 'Choose file'}
              onChange={handleFileChange}
            />
          </Form.Group>
          <div className="d-flex justify-content-center mt-3">
            <Button className="mb-2 mt-2" variant="primary" onClick={handleFileUpload} disabled={selectedFile === null}>
              Upload File and Send Invitations
            </Button>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <Button variant="secondary" style={{ textTransform: 'none' }} onClick={() => selectionMade('back')}>
              Return to Launch Page
            </Button>
          </div>
        </Container>
      </Stack>
    </>
  );
}

export default LaunchUploadContent;
